import { VirtualTableHeadCell } from '../../../virtualized-table/types';

export const startModeHeadCells: VirtualTableHeadCell[] = [
  {
    accessor: 'desiredValue',
    Header: 'Desired Value',
  },
  {
    accessor: 'currentValue',
    Header: 'Current Value',
  },
  {
    accessor: 'status',
    Header: 'Status',
  },
  {
    accessor: 'userId',
    Header: 'User ID',
  },

];

export const switchConfigurationsHeadCells: VirtualTableHeadCell[] = [
  {
    accessor: 'switchNumber',
    Header: 'Switch Number',
  },
  {
    accessor: 'switchType',
    Header: 'Switch Type',
  },
  {
    accessor: 'name',
    Header: 'Name',
  },
  {
    accessor: 'state',
    Header: 'State',
  },
  {
    accessor: 'monitorMode',
    Header: 'Monitor Mode',
  },
  {
    accessor: 'delayTime',
    Header: 'Delay Time',
  },
  {
    accessor: 'status',
    Header: 'Status',
  },
];

export const switchConfigurationsTableSortableAccessors = {
  switchNumber: false,
  switchType: false,
  name: false,
  state: false,
  monitorMode: false,
  delayTime: false,
  status: false,
};
